export const PRODUCT_OFFER_DETAIL_SHOW_DELAY = 600;
export const PRODUCT_OFFER_DETAIL_CLOSE_DELAY = 600;
export const FETCH_OFFLINE_STATUS_DELAY = 10000;
export const PATH_SPLITER = '>';
export const INLINE_CHART_TOGGLE_BUTTON_ID = 'button-chart-toggle';

export const bidType = {
  bidValue: 'bidValue',
  bidBoost: 'bidBoost',
};

export const DEFAULT_CURRENT_PAGE = 0;
export const MAX_PAGE_SIZE = 20000;
export const productGroupLevel = {
  Account: 'account',
  Campaign: 'campaign',
  AdGroup: 'adGroup',
};
